import { fn } from '@common/utils';
import { IInfNotification, InfNotificationEntry, InfNotificationFilter } from '@common/navkendo';
import { CompatibilityService, IDeferred } from '@services/compatibilityservice';

export class KWFNotificationService implements IInfNotification {
    static $inject = ["CompatibilityService"];
    constructor($c: CompatibilityService) {
        const OnAvailable = this.OnAvailable = $c.defer<KWFNotificationService>();
        this.WhenAvailable = OnAvailable.promise;
    }

    /** Promise to be resolved when actual ui interface is available */
    public readonly WhenAvailable: PromiseLike<KWFNotificationService>;

    private readonly OnAvailable: IDeferred<KWFNotificationService>;

    public AddNotification(entry: InfNotificationEntry) {
        var notification = this._Notification;
        if (notification) {
            return notification.AddNotification(entry);
        }
        return fn.noop;
    }

    public RemoveNotifications(filter?: InfNotificationFilter) {
        var notification = this._Notification;
        if (notification) {
            notification.RemoveNotifications(filter);
        }
    }

    /** Attach UI Notification Obj */
    public set Notification(nBar: IInfNotification) {
        if (nBar && typeof nBar.AddNotification == "function") {
            const OnAvailable = this.OnAvailable;
            if (nBar == this) {
                OnAvailable.reject("Invalid Self Reference for NotificationService");
            } else {
                this._Notification = nBar;
                OnAvailable.resolve(this);
            }
        }
    }
    private _Notification: IInfNotification;

}
